import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
    return (
        <div className="max-w-4xl mx-auto py-8">
            <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-100 dark:border-gray-800 p-6 sm:p-8 lg:p-12">
                <h1 className="text-4xl font-bold text-gray-900 dark:text-gray-100 mb-4">Privacy Policy</h1>
                <p className="text-gray-600 dark:text-gray-400 mb-8">Last updated: January 2025</p>

                <div className="prose prose-gray max-w-none">
                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">1. Introduction</h2>
                        <p className="text-gray-700 dark:text-gray-300 mb-4">
                            Welcome to RewriteKing. We respect your privacy and are committed to protecting it. This privacy policy
                            explains our practices regarding data collection and usage when you use our service.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">2. Information We Collect</h2>
                        <p className="text-gray-700 dark:text-gray-300 mb-4">
                            <strong className="text-gray-900 dark:text-gray-100">We do not collect, store, or retain any personal information.</strong> Our service operates entirely client-side:
                        </p>
                        <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                            <li>No user accounts or registration required</li>
                            <li>No cookies or tracking technologies</li>
                            <li>No personal data collection</li>
                            <li>No analytics or usage tracking</li>
                        </ul>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">3. Text Processing</h2>
                        <p className="text-gray-700 dark:text-gray-300 mb-4">
                            When you use our rewriting service, the text you input is sent to our API for processing. This text:
                        </p>
                        <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                            <li>Is processed in real-time to generate rewritten content</li>
                            <li>Is not stored on our servers</li>
                            <li>Is not saved or logged</li>
                            <li>Is not associated with any personal information</li>
                        </ul>
                        <p className="text-gray-700 dark:text-gray-300 mb-4">
                            Once the rewriting process is complete, the text is immediately discarded and not retained in any form.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">4. Third-Party Services</h2>
                        <p className="text-gray-700 dark:text-gray-300 mb-4">
                            Our service uses a third-party API to process text rewriting requests. The text you submit is sent to this
                            API for processing. We do not control the privacy practices of this third-party service. We recommend
                            reviewing their privacy policy if you have concerns about how your text is handled.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">5. Browser Storage</h2>
                        <p className="text-gray-700 dark:text-gray-300 mb-4">
                            Our application may use browser local storage to temporarily store your text input and rewritten output
                            during your session. This data:
                        </p>
                        <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                            <li>Remains entirely on your device</li>
                            <li>Is never transmitted to our servers except for processing</li>
                            <li>Can be cleared at any time by clearing your browser cache</li>
                        </ul>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">6. Changes to This Policy</h2>
                        <p className="text-gray-700 dark:text-gray-300 mb-4">
                            We may update this privacy policy from time to time. Any changes will be posted on this page with an
                            updated revision date. We encourage you to review this policy periodically.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">7. Contact Us</h2>
                        <p className="text-gray-700 dark:text-gray-300 mb-4">
                            If you have any questions about this privacy policy or our privacy practices, please contact us at{' '}
                            <a href="mailto:contact@rewriteking.com" className="text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300">
                                contact@rewriteking.com
                            </a>
                        </p>
                    </section>
                </div>

                <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-800">
                    <Link to="/" className="text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 font-medium">
                        ← Back to Home
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;

